import { Box, styled } from '@mui/material';

const ToolbarBox = styled(Box)`
  display: flex;
  align-items: center;
  flex: 1;
`;

export default ToolbarBox;
